// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hq-0";
export var actionModalContentContainer = "_hq-1";
export var createTagButton = "_hq-2";
export var footerContainer = "_hq-7";
export var fullWidthDivider = "_hq-3";
export var hasCreateTagButton = "_hq-4";
export var noCreateTagButton = "_hq-5";
export var tagsContainer = "_hq-6";
export var tagsModalContentContainer = "_hq-8";